<template>
  <div>
    <svg
      v-if="status === 'new'"
      v-b-popover.html="{
        container: '#app',
        trigger: 'hover blur',
        content: 'Новый кандидат',
        placement: 'top',
      }"
      width="19"
      height="8"
      viewBox="0 0 19 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 7V1L4 7V1M12 1L13 7L15 2L17 7L18 1M7 4V1H10M7 4V7H10M7 4H9"
        stroke="#12C971"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="status === 'dismiss'"
      v-b-popover.html="{
        container: '#app',
        trigger: 'hover blur',
        content: 'После запланированного звонка/тестирования/встречи нет изменений по кандидату',
        placement: 'top',
      }"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 4V7M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z"
        stroke="#FF238D"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle cx="7" cy="10" r="1" fill="#FF238D" />
    </svg>

    <svg
      v-if="status === 'progress'"
      v-b-popover.html="{
        container: '#app',
        trigger: 'hover blur',
        content: `Кандидат ждёт звонка ${scheduledDateTime.date} в ${scheduledDateTime.time}`,
        placement: 'top',
      }"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 4V7L9 8M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z"
        stroke="#8E9CBB"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "candidates-status-icon",
  props: {
    status: {
      type: String,
      default: () => "",
    },
    scheduledDateTime: {
      type: Object,
      default: () => ({
        date: "",
        time: "",
      }),
    },
  },
};
</script>

<style scoped>
div > svg {
  transform: translateY(-2px);
}
</style>
